import React from 'react';
import Client from "./Client";

const ClientsRender = () => {
    return (
        <div className={'flex'}>
            <Client/>
            <Client/>
            <Client/>
        </div>
    );
};

export default ClientsRender;